import base from './base/index';
import vin from './options/vin/index';
import mmy from './options/mmy/index';
import manualSelection from './options/manual-selection/index';

export default {
    namespaced: true,
    modules: {
        base,
        vin,
        mmy,
        manualSelection,
    },
}